/**
 * Where the قرعه‌کشی landing can send someone, off this page.
 *
 * One module so a destination is never typed twice — a campaign link that
 * works in the hero and 404s in the footer is the kind of thing nobody
 * notices until a prospect reports it.
 */

/**
 * The app download page on the marketing site.
 *
 * Deliberately the *page*, not a store link: it already fans out to Cafe
 * Bazaar, Myket, Google Play and a direct APK, and which of those a given
 * Iranian phone can actually install is not something this page can guess.
 */
export const APP_DOWNLOAD_URL = 'https://hamyanapp.com/download'

/**
 * The Eitaa mini app.
 *
 * Bare here: this button is tapped by someone who is ALREADY on the landing,
 * so there is no page to carry them to.
 *
 * ⚠️ This comment used to say Eitaa drops `?startapp=` ("measured on a real
 * device 2026-08-31"). It does not, and believing that note cost a wrong design
 * elsewhere. Production says: between 2026-08-31 and 2026-09-15
 * `lottery_landing_launched` — which only fires from a start param — fired 22
 * times on Eitaa for 16 different invite codes, and a test link opened the
 * landing on both the phone and Eitaa web on 2026-09-17. Whatever was measured
 * that day was most likely `getStartParam()` still reading only the query
 * string. `eitaa.com/hamyan_minibot_app/start?startapp=<value>` works, and the
 * notification links rely on it (`modules/miniapp/notificationOpen.ts`).
 */
export const EITAA_MINIAPP_URL = 'https://eitaa.com/hamyan_minibot_app/start'

/**
 * The marketing site — «معرفی همیان».
 *
 * Deliberately not the download page: somebody who has not decided yet is
 * asking what this is, and answering with an install prompt is answering a
 * question they did not ask.
 */
export const HAMYAN_SITE_URL = 'https://hamyanapp.com'

/** The PWA itself, for «همین حالا در مرورگر». */
export const PWA_URL = 'https://pwa.hamyanapp.com/'

/** Where the demo fund lives, under a given invitation code. */
export const demoPath = (code?: string | null) =>
    code ? `/q/${code}/demo` : '/q/demo'

/** Back to the pitch from inside the demo. */
export const introPath = (code?: string | null) => (code ? `/q/${code}` : '/q')
